import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import '../css/OrigoArrow.less';

export default class OrigoArrow extends React.Component {
    render() {
        const { onClick, disabled, direction, className } = this.props;
        return (
            <div
                className={
                    'origo-arrow ' + className + ' ' + direction + (disabled ? ' disabled' : '')
                }
                onClick={onClick}
            >
                {direction === 'prev' ? <LeftOutlined /> : <RightOutlined />}
            </div>
        );
    }
}
